<template>
    <div>
        <div>
            <van-image v-for="(item,index) in imgList" :src="item" :key="item" @click="openImg(index)">
                <van-image-preview v-model:show="show2" :images="imgList" :startPosition='startPosition'>
                </van-image-preview>
            </van-image>
        </div>
        <!-- <div class="goBack" style="width:20px;height:20px;background:red" @click="goBack"></div> -->
        <div class="flexBack" @click="openBack" v-if="isShow"></div>
    </div>

</template>

<script>
import { ImagePreview } from 'vant';
export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    data(){
        return{
            active:'',
            isShow:false,
            show2:false,
            images2:[
                'https://img.yzcdn.cn/vant/apple-2.jpg',
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
            ],
            imgList:[
                'https://img.yzcdn.cn/vant/apple-2.jpg',
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
                'https://img.yzcdn.cn/vant/apple-1.jpg',
                'https://img.yzcdn.cn/vant/apple-2.jpg',
            ],
            startPosition:''
        }
    },
    beforeRouteLeave(to,from,next){
        console.log(to)
        // console.log(from)
        next()
        if(to.path=="/TabText"){
            next({path:'/TabText'})
        }else{
            next({path:'/'})
        }
        // this.$nextTick(()=>{
        //     if(this.show2){
        //         this.show2 = false
        //         next(false)
        //     }else{
        //         next(true)
        //     }
        // })
    },
    mounted(){
        // this.ssss()
        // if(document.body.offsetHeight+document.body.scrollTop > document.body.offsetHeight){
        console.log(document.body.scrollTop)

        //         this.isShow = true
        //     }
    },
    methods:{
        // ssss(){
        //     if(document.body.offsetHeight+document.body.scrollTop > document.body.offsetHeight){
        //         this.isShow = true
        //     }
        // },
        openImg(index){
            this.show2 = true
            this.startPosition = index
        },
        
        openBack(){
            console.log(document.body.offsetHeight)
            let top = document.documentElement.scrollTop || document.body.scrollTop
            const timeTop = setInterval(() => {
            document.body.scrollTop = document.documentElement.scrollTop = top -= 50
            if (top <= 0) {
                clearInterval(timeTop)
            }
            }, 20)
            // window.scrollTo(0,0,3000)
        }
        // ssss(){
        //     window.scrollTo(0,0)
        // }
    },
    created(){
        // this.goBack()
        // this.active = this.$route.query.active
        // console.log(this.active,'1111111111111')
    }
}
</script>

<style scoped>
.flexBack{
    /* display: flex; */
    position: fixed;
    bottom:25px;
    right: 0;
    width: 30px;
    height:30px;
    background-color: red;
}
</style>